import { useState } from "react";
import { groupApi } from "../api/group.service";
import { DetailAttendantType } from "../types";

export const useGetDetailAttendant = () => {
  const [data, setData] = useState<DetailAttendantType | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);

  const fetchData = async (attendant_id: string) => {
    try {
      setLoading(true);

      const response: any = await groupApi.detailAttendant(attendant_id);

      setData(response?.data?.data[0] ?? null);

      return true;
    } catch (err: any) {
      console.log("Get detail attendant failed:", err);

      setError(err.message || "Something wrong");

      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    data,
    fetchData,
    loading,
    error,
  };
};
